import jet from "@randajan/jet-core";
import { FormSchema } from "./FormSchema";


const { solid } = jet.prop;

export const formsSchema = {};
export default formsSchema;

const addForm = (name, fields)=>{
    solid(formsSchema, name, new FormSchema(name, fields));
}

addForm("chat", {
    src:{ type:"text", max:512, hidden:true },
    msg:{ type:"textarea", label:"Vzkaz pro nás", max:512 },
    name:{ type:"text", label:"Vaše jméno a příjmení", max:32 },
    phone:{ type:"tel", label:"Telefon", max:32 },
    email:{ type:"email", label:"E-mail", max:64 }
});

addForm("review", {
    rating:{ type:"number", label:"Hodnocení", min:0, max:100 },
    text:{ type:"textarea", label:"Vaše zkušenost s námi", max:512 },
    name:{ type:"text", label:"Vaše jméno a příjmení", max:32 },
    phone:{ type:"tel", label:"Telefon", max:32 },
    email:{ type:"email", label:"E-mail", max:64 },
});